import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store';
import Default from '../template/Default.vue';
import Home from '../views/Home.vue';
import Dashboard from '../views/Dashboard.vue';
import Sign from '../views/Sign.vue';
import Assignment from '../views/Assignment.vue';
import Submit from '../views/Submit.vue';
import SubmitDone from '../views/SubmitDone.vue';
import V404 from '../views/404.vue';

Vue.use(VueRouter);

const needAuth = {
  meta: {
    needAuth: true,
  },
};

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Default',
    component: Default,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        ...needAuth,
      },
      {
        path: '/assignment/:id',
        name: 'Assignment',
        component: Assignment,
        props: true,
        ...needAuth,
      },
      {
        path: 'submit/:id',
        name: 'Submit',
        component: Submit,
        props: true,
      },
      {
        path: 'submit-done',
        name: 'SubmitDone',
        component: SubmitDone,
      },
      {
        path: '404',
        name: '404',
        component: V404,
      },
    ],
  },
  {
    path: '/sign',
    name: 'Sign',
    component: Sign,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.needAuth && !store.getters.user.loggedIn) {
    next('/sign');
  } else {
    next();
  }
});

export default router;
